module.exports = __webpack_public_path__ + "static/media/bold.4b27cf27.svg";